import { fileUrl } from "@/lib/api";
import { contrastText } from "@/lib/format";

export function GarageAvatar({ garage, size = "md" }) {
  const dim = size === "sm" ? "h-9 w-9 text-sm" : size === "lg" ? "h-16 w-16 text-2xl" : "h-12 w-12 text-lg";
  if (garage?.logo_url) {
    return <img src={fileUrl(garage.logo_url)} alt={garage.name} data-testid="garage-logo-image" className={`${dim} shrink-0 rounded-lg bg-white object-contain p-0.5`} />;
  }
  const color = garage?.primary_color || "#0D9488";
  return (
    <span data-testid="garage-logo-fallback" className={`${dim} flex shrink-0 items-center justify-center rounded-lg font-display font-extrabold`} style={{ background: color, color: contrastText(color) }}>
      {(garage?.name || "?").slice(0, 1).toUpperCase()}
    </span>
  );
}
